import { render } from "./PandoraPagination.vue?vue&type=template&id=2be51144"
import script from "./PandoraPagination.vue?vue&type=script&lang=js"
export * from "./PandoraPagination.vue?vue&type=script&lang=js"

import "./PandoraPagination.vue?vue&type=style&index=0&id=2be51144&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__